<script>
	export let conditions;
	let buttons = ["share", "like", "bookmark", "accuracy", "upvote", "downvote"];
	let inputOptions = ["no", "yes", "lognormal"];
	let inputDefaultValue = "no";
	let buttonParams = [];

	const getStorage = (conditions) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		if (params) {
			if (params.buttonParams) {
				buttonParams = params["buttonParams"];
			}
		} else {
			params = {};
		}
		// if no button parameters in localStorage yet, create and populate it with default value
		if (!buttonParams) {
			buttonParams = [];
			for (let i = 0; i < conditions; i++) {
				buttonParams.push({});
				for (let j = 0; j < buttons.length; j++) {
					buttonParams[i][buttons[j]] = inputDefaultValue;
				}
			}
		} else {
			// if button parameters in localStorage, check if it has the right number of conditions
			if (buttonParams.length < conditions) {
				// if not, add the missing conditions
				for (let i = buttonParams.length; i < conditions; i++) {
					buttonParams.push({});
					for (let j = 0; j < buttons.length; j++) {
						buttonParams[i][buttons[j]] = inputDefaultValue;
					}
				}
			}
		}
		params["buttonParams"] = buttonParams;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	getStorage();
	$: getStorage(conditions);

	const updateStorage = (parameters) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		params["buttonParams"] = parameters;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	$: updateStorage(buttonParams);

	const formatForAPI = (conditions, parameters, parameterName) => {
		// console.log(parameters);
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);
		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			for (let j = 0; j < buttons.length; j++) {
				formatted.push({
					condition: i + 1,
					param: parameterName + "-" + buttons[j],
					value: parameters[i][buttons[j]],
				});
			}
		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected)
		);
	};
	$: formatForAPI(conditions, buttonParams, "feed-button");
</script>

<hr />
<h3>Buttons</h3>
<div>
	<p>
		If you do not select any button (default <strong>no</strong>), all
		buttons will be shown.
	</p>
	<p>
		If you want only a button but not any social cues/engagement info, enter <strong
			>yes</strong
		>.
	</p>
	<p>
		If you want a button <em>and</em> social cues/engagement metrics, enter
		<strong>lognormal</strong>.
	</p>
</div>

{#each { length: conditions } as _, ii}
	<p><strong>Condition {ii + 1}</strong></p>
	{#each buttons as button}
		<div class="button-container">
			<label
				for={"condition-" + (ii + 1) + ";feed-button-" + button}
				class="card-label">{button}</label
			>
			<input
				name={"condition-" + (ii + 1) + ";feed-button-" + button}
				type="text"
				list="button-options"
				class="button-input"
				placeholder="no"
				bind:value={buttonParams[ii][button]}
			/>
			<datalist id="button-options">
				{#each inputOptions as inputOption}
					<option value={inputOption} />
				{/each}
			</datalist>
		</div>
	{/each}
{/each}

<style>
	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 8px;
	}

	.card-label {
		display: inline;
	}

	.button-input {
		width: 89px;
		display: inline;
	}

	.button-container {
		display: inline;
	}

	@media (max-width: 950px) {
		.button-container {
			display: block;
		}
	}
</style>
